/**
 * Рукописный клиент — этих ручек нет в OpenAPI-спеке, генерация Kubb их не
 * покрывает (7 вызовов, ни одного эквивалента). Поэтому модуль остаётся
 * рукописным; при появлении ручек в спеке — переходить на сгенерированные
 * хуки (KAN-1000).
 */
import { api } from "@/shared/lib/api";
import type {
  LfgLftPostListParams,
  LfgLftPostListResponse,
  LfgLftPostResponse,
  CreateLfgLftPostRequest,
  UpdateLfgLftPostRequest,
  LfgLftApplicationResponse,
  CreateLfgLftApplicationRequest,
  PatchLfgLftApplicationRequest,
} from "./lfg-lft-types";

const BASE = "/lfg-lft-posts";

function buildQuery(params: LfgLftPostListParams): string {
  const q = new URLSearchParams();
  if (params.type) q.set("type", params.type);
  if (params.minRank) q.set("minRank", params.minRank);
  if (params.maxRank) q.set("maxRank", params.maxRank);
  if (params.status) q.set("status", params.status);
  if (params.mic) q.set("mic", params.mic);
  if (params.hoursUtcMask) q.set("hoursUtcMask", String(params.hoursUtcMask));
  if (params.q) q.set("q", params.q);
  if (params.sort) q.set("sort", params.sort);
  // Массивы — повтором ключа: так их связывает [FromQuery] string[] в ASP.NET.
  for (const r of params.roles ?? []) q.append("roles", r);
  for (const s of params.servers ?? []) q.append("servers", s);
  for (const f of params.searchPurposes ?? []) q.append("searchPurposes", f);
  for (const l of params.languages ?? []) q.append("languages", l);
  if (params.page != null) q.set("page", String(params.page));
  if (params.pageSize != null) q.set("pageSize", String(params.pageSize));
  const s = q.toString();
  return s ? `?${s}` : "";
}

export async function fetchLfgLftList(
  params: LfgLftPostListParams = {}
): Promise<LfgLftPostListResponse> {
  const res = await api.get<LfgLftPostListResponse>(`${BASE}${buildQuery(params)}`);
  return res.data;
}

export async function fetchLfgLftPost(id: string): Promise<LfgLftPostResponse | null> {
  const res = await api.get<LfgLftPostResponse>(`${BASE}/${id}`);
  return res.data ?? null;
}

export async function createLfgLftPost(
  body: CreateLfgLftPostRequest
): Promise<LfgLftPostResponse> {
  const res = await api.post<LfgLftPostResponse>(BASE, body);
  return res.data;
}

export async function updateLfgLftPost(
  id: string,
  body: UpdateLfgLftPostRequest
): Promise<LfgLftPostResponse> {
  const res = await api.patch<LfgLftPostResponse>(`${BASE}/${id}`, body);
  return res.data;
}

export const lfgLftQueryKeys = {
  all: ["lfg-lft-posts"] as const,
  list: (params: LfgLftPostListParams) =>
    [...lfgLftQueryKeys.all, "list", params] as const,
  detail: (id: string) => [...lfgLftQueryKeys.all, "detail", id] as const,
};

const APP_BASE = "/lfg-lft-applications";

export async function fetchLfgLftApplicationsIncoming(): Promise<LfgLftApplicationResponse[]> {
  const res = await api.get<LfgLftApplicationResponse[]>(`${APP_BASE}/incoming`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function fetchLfgLftApplicationsOutgoing(): Promise<LfgLftApplicationResponse[]> {
  const res = await api.get<LfgLftApplicationResponse[]>(`${APP_BASE}/outgoing`);
  return Array.isArray(res.data) ? res.data : [];
}

export async function createLfgLftApplication(
  postId: string,
  body: CreateLfgLftApplicationRequest
): Promise<LfgLftApplicationResponse> {
  const res = await api.post<LfgLftApplicationResponse>(`/lfg-lft-posts/${postId}/applications`, body);
  return res.data;
}

export async function patchLfgLftApplication(
  id: string,
  body: PatchLfgLftApplicationRequest
): Promise<LfgLftApplicationResponse> {
  const res = await api.patch<LfgLftApplicationResponse>(`${APP_BASE}/${id}`, body);
  return res.data;
}

export const lfgLftAppQueryKeys = {
  all: ["lfg-lft-applications"] as const,
  incoming: () => [...lfgLftAppQueryKeys.all, "incoming"] as const,
  outgoing: () => [...lfgLftAppQueryKeys.all, "outgoing"] as const,
};
